import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React, { Component } from "react";

const styles = {
  card: {
    minWidth: 275
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)"
  },
  title: {
    fontSize: 14
  },
  pos: {
    marginBottom: 12
  },
  section: {
    color: "#005458",
    fontWeight: "bold",
    paddingTop: 10,
    paddingBottom: 10,
    textDecoration: "underline"
  },
  listContainer: {
    color: "rgba(0, 0, 0, 0.87)",
    fontSize: "0.875rem",
    fontFamily: "Noto Sans",
    fontWeight: "400",
    lineHeight: "1.5"
  }
};

class HelpForBasic extends Component {
  state = {};
  render() {
    const { classes } = this.props;
    return (
      <Card className={classes.card}>
        <CardContent>
          <Typography variant="h5" component="h2">
            NTRAC Basic Plan Setup and User Guide
          </Typography>{" "}
          <Typography
            style={{ marginLeft: 0 }}
            className={classes.pos}
            color="textSecondary"
          >
            Last Updated: September 10, 2019{" "}
          </Typography>{" "}
          <br></br>
          <Typography variant="body2" component="p">
            Welcome to NTRAC! Thank you for choosing to use our service. Our #1
            goal is to help farmers with harvest and contract management both
            internally on your farm and improving delivery and transactions in
            the agriculture marketplace. The following is a quick start guide to
            help you in setup and use of NTRAC. We are available to help at any
            point during set up or use; please do not hesitate to contact us at
            <a
              href="mailto:support@novustrac.com"
              style={{ color: "blue" }}
              linkto
            >
              {" "}
              support@novustrac.com
            </a>{" "}
            or call us at +1 620 518 2069.
          </Typography>{" "}
          <br></br>
          <Typography>
            <b>Browser recommendation for the webapp:</b> For best performance
            of the NTRAC webapp platform(for setup, risk, reports, and
            reconciliation), please use a <b>Chrome(by Google) Browser</b>.
          </Typography>
          <br></br>
          <Typography>
            <b>NTRAC App:</b> For iOS(Apple) and Android systems. Please find in
            your Apple App Store or Google Play Store. Free to download. App use
            and instructions are on Page 4.
          </Typography>
          <br></br>
          <Typography>
            <b>NTRAC Website(Webapp) Use and Instructions</b>
          </Typography>
          <ul
            className={classes.listContainer}
            style={{ listStyleType: "decimal" }}
          >
            <li style={{ fontWeight: "bold" }}> Setup </li>
            <li style={{ fontWeight: "bold" }}> Home </li>
            <li style={{ fontWeight: "bold" }}> Reports </li>
            <li style={{ fontWeight: "bold" }}> Risk Management </li>
            <li style={{ fontWeight: "bold" }}> Reconciliation </li>
            <li style={{ fontWeight: "bold" }}> Settings </li>
          </ul>
          <Typography variant="body2" component="p">
            <b>
              {" "}
              1. Setup(preferable to complete this step on a laptop or desktop
              computer)
            </b>{" "}
          </Typography>
          <br></br>
          <Typography>
            After signing up the first step of NTRAC comes in inputting the
            details of your farm. It is strongly preferred to view and operate
            setup on a laptop or desk top computer due to size of the steps and
            screens needed. This step is designed to customize NTRAC to fit your
            farm and make the data or information entry of contracts and tickets
            later on easier and reduce errors of manual input. This information
            will populate the dropdown menus later on for contract and ticket
            input.
          </Typography>
          <br></br>
          <Typography>
            After signing up, you will receive an email confirming your signup
            and NTRAC package. Following that, go to{" "}
            <a href="https://novustrac.com" style={{ color: "blue" }}>
              https://novustrac.com
            </a>{" "}
            and select the LOG IN button at the top right of the screen. Enter
            your login details as the owner of the account and select “Farm set
            up” on the left side of the screen. This the area of the NTRAC
            platform that you or possibly assigned Admin person. If you decide
            to have another person on your farm team add the “Farm set up”
            information, see the “Settings” section of this guide to add an
            Admin person who will have the same access to NTRAC via their
            assigned login to set up the customized details of the farm in
            NTRAC.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b>Select Farm Setup on the left side of your screen</b>
          </Typography>
          <br></br>
          <Typography>Add Your Fields</Typography>
          <br></br>
          <Typography>
            In Setup, select Farm Information ->Field Groups. Select New Group and
            enter a name for a group of fields for your whole farm or different
            field groups within your farm. This step is a headline name, not the
            name of one of your fields. After saving the Field Group name(s),
            select the “+” sign under “Fields Count” to start adding fields for
            your farm. A button “New Field” will appear on the screen to add a
            new field after this initial step. To add new fields after this
            initial add in of your fields, please select the number below
            “Fields Count” to add new fields
          </Typography>
          <br></br>
          <Typography>Add Your Load Number Indicators</Typography>
          <br></br>
          <Typography>
            In Setup, select Farm information ->Field Groups ->select the “+” sign
            below “Load Number Count.” This area of NTRAC allows a farm to
            assign a harvest load count using the Load Number Indicator to
            highlight an acronym assigned to the load count. For example, a
            farmer may want to have a continuous Whole Farm Count as the Load
            Number Indicator Type with WFC as the Load Number Indicator Code. A
            farmer also many want to have a separate count for corn and a
            separate count for soybeans. A farmer may also want a separate count
            for loads hauled to internal storage on his or her farm. NTRAC gives
            you the freedom to add these indicators that make the most sense for
            your farm. To add any extra Load Number Indicators after the initial
            Setup, just click on the highlighted number below “Load Number
            Count.”
          </Typography>
          <br></br>
          <Typography>Add your Trucklines</Typography>
          <br></br>
          <Typography>
            In this step, add both your Farm Owned Trucks as well as any
            external Truckline your farm may use. Click on “Trucklines” and add
            your Trucklines. More specific information can be added later in the
            load ticket process(for example truck number and driver name); this
            step allows all of your hauling trucks and services to appear in the
            dropdown menu.
          </Typography>
          <br></br>
          <Typography>Add your Destinations</Typography>
          <br></br>
          <Typography>
            Add the locations where your farm physically delivers its grain,
            both internal(on farm) and external(off farm) destinations. Click on
            Destination ->Internal or External -> Select New internal destination or
            New external destination. The Estimated Load Cost per Bushel ($)
            cell is a cost per bushel entry cell that will help calculate cost
            per load using the Field Estimated Load Bushels cell in the ticket.
          </Typography>
          <br></br>
          <Typography>Add your Counterparties</Typography>
          <br></br>
          <Typography>
            Add the Counterparties is the section which are all the direct
            delivery locations and brokers that pay a farmer for production
            deliveries. Many of these entries will be the same as the external
            delivery locations but not always(for example when a broker is
            used). For this reason, all the external delivery locations from
            Destinations will be automatically added to counterparties. All you
            need to add are the brokers and other counterparties that may pay
            you but are not in the list from external delivery locations under
            “Destinations.” Click on Counterparties ->New Counterparts to add
            counterparties, like brokers, that pay you, the user, but are not
            delivery destinations.
          </Typography>
          <br></br>
          <Typography>Commodities</Typography>
          <br></br>
          <Typography>
            This set of commodities are static and are not changeable within
            NTRAC. If you wish to add a variety of those commodities, see the
            “Add your Commodity Varieties” section below.
          </Typography>
          <br></br>
          <Typography>Add your Commodity Varieties</Typography>
          <br></br>
          <Typography>
            Add Commodity Varieties to this section to use as the dropdown menu
            in your tickets or contracts. A “variety” that is pre-loaded in your
            NTRAC account is a general commodity that can be used but adding
            commodity varieties to your account allows you to be more specific
            if you wish to do so. Click on Commodity Varieties ->New commodity
            variety to add a variety specific to your farm
          </Typography>
          <br></br>
          <Typography>On-Site Storage</Typography>
          <br></br>
          <Typography>
            All on-site storage locations are added from the Internal section
            under Destinations, for example all internal destinations are also
            added to the On-Site Storage section. This section describes all on
            farm locations used to originate loads that are delivered to
            external destinations or possibly other internal destinations.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b>2. Home</b>
          </Typography>
          <br></br>
          <Typography>
            Contract and Ticket entry. Created New Contracts and New tickets to
            be entered into the NTRAC platform. All of your Setup effort pays
            off here by way of data entry and dropdown menu.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b>3. Reports</b>
          </Typography>
          <br></br>
          <Typography>
            Run reports here with the designated cross sections of data to
            either export to excel(a csv file for use or convert the csv file to
            desired excel format). A powerful screen to pull data and run
            reports with all of your harvest information entered into the
            tickets.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b>4. Risk Management</b>
          </Typography>
          <br></br>
          <Typography>
            For use and access please upgrade to Basic Plus, Enterprise, or
            Enterprise Plus plans.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b>5. Reconciliation</b>
          </Typography>
          <br></br>
          <Typography>
            For use and access please upgrade to Basic Plus, Enterprise, or
            Enterprise Plus plans.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b>6. Settings</b>
          </Typography>
          <br></br>
          <Typography>
            Within Settings, the owner can add users to their NTRAC account and
            make changes to mandatory cells for data entry.
          </Typography>
          <br></br>
          <Typography>
            There are two user types an NTRAC account owner can add to the
            platform, Account Admin and Farm Employee. When an owner or Account
            Admin user adds a new user always using the intended user’s email
            address as the username, the intended user will receive their login
            details via email.
          </Typography>
          <br></br>
          <Typography>
            An owner level or admin level access can turn on or off any user’s
            ability to log into the platform with the “status” switch which adds
            an extra level of security above the log in access.
          </Typography>
          <br></br>
          <Typography>Users access levels:</Typography>
          <ul
            className={classes.listContainer}
            style={{ listStyleType: "lower-alpha" }}
          >
            <li>
              {" "}
              Owner Level – This is the default type of account for the owner or
              user that signs up for the NTRAC platform. The owner can then add
              Account Admin and Farm Employee users for access to their NTRAC
              account.{" "}
            </li>{" "}
            <li>
              {" "}
              Admin Level – Adding this type of user to the platform gives them
              full access to all screens just as the Owner Level account does,
              including adding other Account Admin and Farm Employee users to
              the Owner Level NTRAC account.{" "}
            </li>{" "}
            <li>
              {" "}
              Farm Employee Level – An account added by either an account Owner
              or Admin Level. The Farm Employee can only add tickets to the
              NTRAC platform and does not have write access to any other part of
              the platform. This user cannot access or view reports, risk
              management, or reconciliation.
            </li>
          </ul>
          <Typography>
            In clicking on “mandatory cells” in Settings, an owner or admin user
            can make additional cells for data entry mandatory in the ticket
            entry screen in both the webapp and app. A ticket in the webapp or
            app cannot be saved or printed until all mandatory cells, marked
            with an asterisk(*), are filled in.
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b>NTRAC App Use and Instructions</b>
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b>1. Down from Apple or Google app stores. Free to download.</b>
          </Typography>
          <br></br>
          <Typography variant="body2" component="p">
            <b>2. Using the app</b>
          </Typography>
          <ul
            className={classes.listContainer}
            style={{ listStyleType: "lower-alpha" }}
          >
            <li>
              Once the app is downloaded on to your Apple device or Android
              device, a user must enter his or her login information to access
              the platform. The app is used primarily for contract and ticket
              entry along with contract and ticket display for your farm.
              <br></br>
              Toggle back and forth between viewing and creating tickets and
              contracts at the top of the screen.
              <br></br>
              <b>
                Creating contracts and ticket is started by selecting the
                “Create Contract” or “Create Ticket” button at the bottom of the
                screen.
              </b>
            </li>{" "}
            <li>
              Printer Setup
              <br></br>
              Turn on Bluetooth in the your Brother printer. Turn on Bluetooth
              in your settings on your device. In your device, find the printer
              Bluetooth printer signal(usually starts with rj3050…) and pair
              your device with that selected Brother RJ3050 printer. Make sure
              the printer pairing signal matches the serial number on the bottom
              of the printer(the printer Bluetooth signal name usually includes
              the last 5 digits of the serial number on the bottom of the
              printer).
              <br></br>
              In the app, go to Printer Setup in the menu icon I the top left
              corner and select Printer Setup. For port, select Bluetooth. Under
              Printer Name, select the printer. After selecting the Printer
              Name, the serial number on the bottom of the printer will appear
              in the Serial Number cell. Verify that serial number matches the
              serial number on the bottom of the printer. Select the default
              number of copies you would like to preset for each print job sent
              to the printer. Paper size is preset in the system; leave at 76mm.
              Select Save.
              <br></br>
              Now you are ready to print to your Brother RJ3050 printer from
              your mobile device!
            </li>
          </ul>
          <Typography variant="body2" component="p">
            Thank you for using NTRAC and using NTRAC safely. Please reach out
            to support for any questions or suggestions!{" "}
          </Typography>
        </CardContent>
      </Card>
    );
  }
}

export default withStyles(styles)(HelpForBasic);



// WEBPACK FOOTER //
// ./src/components/private/HelpForBasic.js